export default __webpack_public_path__ + "static/media/quokkas.0b215f87.webm";